import { create } from 'zustand';
import toast from 'lib/utils/toast';
import { queryLotteryChance } from 'lib/apis';

type Store = {
  freeLotteryActivityId: number | null;
  freeLotteryChance: number;
  initialized: boolean;
  initFreeLotteryStore: (params: { activtyId: number }) => void;
  queryFreeLotteryInfo: (initFlag: boolean) => void;
};

export const useFreeLotteryStore = create<Store>((set, get) => ({
  freeLotteryActivityId: null,
  freeLotteryChance: 0,
  initialized: false,
  initFreeLotteryStore: ({ activtyId }) => {
    set({
      freeLotteryActivityId: activtyId,
      freeLotteryChance: 0,
    });
  },
  queryFreeLotteryInfo: async (initFlag = false) => {
    const { freeLotteryActivityId: actId, initialized } = get();
    // 防止重复的初始化请求，新增多个组件，会请求多次
    if (initFlag && initialized) return;
    toast.loading();
    set({
      initialized: true,
    });
    const res = await queryLotteryChance({ actId });
    toast.close();
    if (res?.code !== 0) {
      set({
        initialized: false,
      });
      return;
    }
    const { remainingCount, totalCount, dayCount, weekCount } = res.data;
    // 任意一个为0，均为无免费抽奖机会
    const remainingChance = remainingCount !== 0 && totalCount !== 0 && dayCount !== 0 && weekCount !== 0;
    set({
      freeLotteryChance: remainingChance ? 1 : 0,
    });
  },
}));
